export const getAppVersion = (state) => state.appVersion?.currentVersion;
export const getIsRunningLatestVersion = (state) => state.appVersion?.isRunningLatestVersion;
export const getShouldShowUpdateModal = (state) => state.appVersion?.shouldShowUpdateModal;
